
export const ServicePrivileges = Object.freeze({
  Accountant: {
    value: 'ACCOUNTANT',
    label: 'Facturation'
  },
  Operator: {
    value: 'OPERATOR',
    label: 'Opérateur de télésuivi'
  },
  Prescriber: {
    value: 'PRESCRIBER',
    label: 'Prescripteur'
  },
  Manager: {
    value: 'MANAGER',
    label: 'Manager'
  },
  SuperAdmin: {
    value: 'SUPER_ADMIN',
    label: 'Super admin'
  }
})
